import { ISettingsState } from "./types";
import UserInterface from "@/types/app/IUser";
import Auth from "@/plugins/auth";

const auth = new Auth();

export default {
  getUser(state: ISettingsState): UserInterface {
    return state.user;
  },
  getUsers(state: ISettingsState): UserInterface[] {
    return state.users;
  },
  getIslogged(state: ISettingsState): boolean {
    return state.user != null ? true : false;
  },
  getErrorStatus(state: ISettingsState): boolean {
    return state.error;
  }
};
